import AccountingDocumentState from "../shared/documentInfrastructure/AccountingDocumentState.js";

/**
 * Hold the state for the search the ledger document.
 */
export default class SearchDocumentState extends AccountingDocumentState {
	getSearchPeriod() {
		return this._searchPeriod;
	}

	getCompany() {
		return this._company;
	}

	isSearching() {
		return this._isSearching;
	}

	async searchLedger(...rest) {
		this._isSearching = true;

		try {
			return await this._service.searchLedger(...rest);
		} finally {
			this._isSearching = false;
		}
	}

	_setupInitialData({ searchPeriod, company }) {
		this._searchPeriod = searchPeriod;
		this._company = company;

		this._isSearching = false;
	}
}
